require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-joan-kerulis-promoted-to-svp-of-internal-audit-at-financial-center.json") })
        }
      }, "path---es-articles-joan-kerulis-promoted-to-svp-of-internal-audit-at-financial-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-joan-kerulis-promoted-to-svp-of-internal-audit-at-financial-center!./.cache/json/es-articles-joan-kerulis-promoted-to-svp-of-internal-audit-at-financial-center.json
// module id = 2214
// module chunks = 231608221292675